import { LocationPinIcon, ThemeIcon, Tooltip } from '@libs/ui/ds'
import { NUMBER_OF_DAYS_BEFORE_DELETION } from '@libs/utils/environments'
import { useTimeLockReportTranslation } from '@libs/utils/translations'
import moment from 'moment/moment'
import type { FC } from 'react'
import React from 'react'

type UnknownLocationControlProps = {
  event_occurred_at?: string
}

export const isLocationDeleted: (
  event_occurred_at: string
) => boolean = event_occurred_at =>
  moment().diff(moment.parseZone(event_occurred_at), 'days') >
  NUMBER_OF_DAYS_BEFORE_DELETION

export const UnknownLocationControl: FC<UnknownLocationControlProps> = ({
  event_occurred_at
}) => {
  const { t } = useTimeLockReportTranslation()

  const labelText =
    event_occurred_at && isLocationDeleted(event_occurred_at)
      ? t('timeClockReport.clockControl.deletedAfterDelay')
      : t('timeClockReport.clockControl.unknown')

  return (
    <Tooltip label={labelText}>
      <ThemeIcon icon={<LocationPinIcon />} color='neutral' />
    </Tooltip>
  )
}
